<span class="badge float-right" [class]="getBadgeStatusColor(status)">{{status}}</span>
